<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html,body {
    margin: 0;
    padding: 0;
    height: 100%;
    background:#F3F3F5;
  }
  #app {
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #063b5a27;
    border-radius: 10px;
  }
  .el-table th {
    background: #E8F3FF;
    color: #5871A7;
  }
  .table-content {
    background: #ffffff;
    padding-bottom: 5px;
  }
  .table-content .table-page {
    margin-top: 10px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue